import React, { useEffect, useState } from "react";
import { Box, Typography, Grid, Avatar, Divider, Button, Chip } from "@mui/material";
import { SideBarWidth } from "../../utils/SideBarWidth";
import { WalletsRequests } from "../../api/requests/Wallets/wallets";
import { useNavigate } from "react-router-dom";
import AccountBalanceWalletIcon from "@mui/icons-material/AccountBalanceWallet";
import ArrowUpwardIcon from "@mui/icons-material/ArrowUpward";
import ArrowDownwardIcon from "@mui/icons-material/ArrowDownward";
import ArrowForwardIcon from "@mui/icons-material/ArrowForward";
import ReceiptLongIcon from "@mui/icons-material/ReceiptLong";
import PaymentsIcon from "@mui/icons-material/Payments";
import GetValidatedTokenData from "../../utils/helper";

export default function Wallet() {
  const navigate = useNavigate();
  const [walletBalance, setWalletBalance] = useState("0");
  const [totalCredit, setTotalCredit] = useState("0");
  const [totalWithdrawal, setTotalWithdrawal] = useState("0");
  const [recentTxns, setRecentTxns] = useState([]);
  const [shortcode, setShortcode] = useState("---");

  useEffect(() => {
    const data = GetValidatedTokenData();
    if (data?.userPayload?.shortcode) setShortcode(data.userPayload.shortcode);

    const fetchWallet = async () => {
      try {
        const response = await WalletsRequests.getWalletHistory();
        const txns = response?.data || [];
        let credit = 0, withdrawal = 0;
        txns.forEach((t) => {
          if (t.type === "CREDIT") credit += parseFloat(t.amount);
          else if (t.type === "WITHDRAWAL") withdrawal += parseFloat(t.amount);
        });
        setTotalCredit(credit.toLocaleString("en-IN"));
        setTotalWithdrawal(withdrawal.toLocaleString("en-IN"));
        setWalletBalance((credit - withdrawal).toLocaleString("en-IN"));
        setRecentTxns(txns.slice(0, 5));
      } catch (error) {}
    };
    fetchWallet();
  }, []);

  return (
    <Box sx={{
      width: { xs: "100%", md: `calc(100% - ${SideBarWidth}px)` },
      ml: { md: `${SideBarWidth}px` },
      minHeight: "100vh", backgroundColor: "#F8FAFC",
    }}>
      <Box sx={{ px: { xs: 2, md: 3 }, py: 3, maxWidth: 1000 }}>
        <Box sx={{ mb: 3 }}>
          <Box sx={{ display: "flex", alignItems: "center", gap: 1, mb: 0.5 }}>
            <AccountBalanceWalletIcon sx={{ fontSize: 22, color: "#059669" }} />
            <Typography sx={{ fontWeight: 700, color: "#0F172A", fontSize: { xs: "20px", md: "24px" }, letterSpacing: "-0.02em" }}>
              Wallet
            </Typography>
          </Box>
          <Typography sx={{ color: "#64748B", fontSize: "13px" }}>
            Manage your wallet balance and transactions
          </Typography>
        </Box>

        {/* Balance Card - White with green */}
        <Box sx={{
          p: { xs: 2.5, md: 3 }, borderRadius: "16px", mb: 3,
          backgroundColor: "#FFFFFF",
          border: "1px solid #E2E8F0",
        }}>
          <Box sx={{ display: "flex", alignItems: "center", justifyContent: "space-between", mb: 1 }}>
            <Typography sx={{ fontSize: "12px", fontWeight: 600, color: "#94A3B8", textTransform: "uppercase", letterSpacing: "1px" }}>
              Available Balance
            </Typography>
            <Chip label={shortcode} size="small" sx={{
              height: 20, fontSize: "10px", fontWeight: 700,
              backgroundColor: "#F1F5F9", color: "#64748B",
              "& .MuiChip-label": { px: 0.8 },
            }} />
          </Box>
          <Typography sx={{ fontWeight: 700, fontSize: { xs: "32px", md: "40px" }, lineHeight: 1.2, color: "#059669", letterSpacing: "-0.02em" }}>
            Rs. {walletBalance}
          </Typography>
        </Box>

        {/* Stats */}
        <Grid container spacing={2} sx={{ mb: 3 }}>
          <Grid item xs={6}>
            <Box sx={{
              p: 2.5, borderRadius: "12px", backgroundColor: "#FFFFFF",
              border: "1px solid #E2E8F0",
            }}>
              <Box sx={{ display: "flex", alignItems: "center", gap: 1, mb: 1 }}>
                <Avatar sx={{ width: 32, height: 32, backgroundColor: "#D1FAE5", color: "#059669" }}>
                  <ArrowUpwardIcon sx={{ fontSize: 16 }} />
                </Avatar>
                <Typography sx={{ fontSize: "11px", fontWeight: 600, color: "#64748B", textTransform: "uppercase", letterSpacing: "0.5px" }}>
                  Total Credit
                </Typography>
              </Box>
              <Typography sx={{ fontWeight: 700, fontSize: "22px", color: "#059669" }}>
                Rs. {totalCredit}
              </Typography>
            </Box>
          </Grid>
          <Grid item xs={6}>
            <Box sx={{
              p: 2.5, borderRadius: "12px", backgroundColor: "#FFFFFF",
              border: "1px solid #E2E8F0",
            }}>
              <Box sx={{ display: "flex", alignItems: "center", gap: 1, mb: 1 }}>
                <Avatar sx={{ width: 32, height: 32, backgroundColor: "#FEF2F2", color: "#EF4444" }}>
                  <ArrowDownwardIcon sx={{ fontSize: 16 }} />
                </Avatar>
                <Typography sx={{ fontSize: "11px", fontWeight: 600, color: "#64748B", textTransform: "uppercase", letterSpacing: "0.5px" }}>
                  Total Withdrawn
                </Typography>
              </Box>
              <Typography sx={{ fontWeight: 700, fontSize: "22px", color: "#EF4444" }}>
                Rs. {totalWithdrawal}
              </Typography>
            </Box>
          </Grid>
        </Grid>

        {/* Quick Actions */}
        <Grid container spacing={2} sx={{ mb: 3 }}>
          <Grid item xs={6}>
            <Box
              onClick={() => navigate("/withdrawal")}
              sx={{
                p: 2.5, borderRadius: "12px", backgroundColor: "#FFFFFF",
                border: "1px solid #E2E8F0", cursor: "pointer",
                transition: "all 0.2s", display: "flex", alignItems: "center", gap: 2,
                "&:hover": { borderColor: "#059669", boxShadow: "0 4px 12px rgba(5,150,105,0.1)", transform: "translateY(-1px)" },
              }}
            >
              <Avatar sx={{ width: 40, height: 40, backgroundColor: "#D1FAE5", color: "#059669" }}>
                <ReceiptLongIcon sx={{ fontSize: 20 }} />
              </Avatar>
              <Box>
                <Typography sx={{ fontWeight: 600, fontSize: "14px", color: "#0F172A" }}>Withdraw</Typography>
                <Typography sx={{ fontSize: "11px", color: "#64748B" }}>Request payout</Typography>
              </Box>
            </Box>
          </Grid>
          <Grid item xs={6}>
            <Box
              onClick={() => navigate("/transactions")}
              sx={{
                p: 2.5, borderRadius: "12px", backgroundColor: "#FFFFFF",
                border: "1px solid #E2E8F0", cursor: "pointer",
                transition: "all 0.2s", display: "flex", alignItems: "center", gap: 2,
                "&:hover": { borderColor: "#2563EB", boxShadow: "0 4px 12px rgba(37,99,235,0.1)", transform: "translateY(-1px)" },
              }}
            >
              <Avatar sx={{ width: 40, height: 40, backgroundColor: "#EFF6FF", color: "#2563EB" }}>
                <PaymentsIcon sx={{ fontSize: 20 }} />
              </Avatar>
              <Box>
                <Typography sx={{ fontWeight: 600, fontSize: "14px", color: "#0F172A" }}>Transactions</Typography>
                <Typography sx={{ fontSize: "11px", color: "#64748B" }}>View history</Typography>
              </Box>
            </Box>
          </Grid>
        </Grid>

        {/* Recent Transactions */}
        <Box sx={{ backgroundColor: "#FFFFFF", borderRadius: "12px", border: "1px solid #E2E8F0", overflow: "hidden" }}>
          <Box sx={{ px: 3, py: 2, display: "flex", alignItems: "center", justifyContent: "space-between" }}>
            <Typography sx={{ fontWeight: 700, fontSize: "15px", color: "#0F172A" }}>
              Recent Transactions
            </Typography>
            <Button
              size="small" endIcon={<ArrowForwardIcon sx={{ fontSize: 14 }} />}
              onClick={() => navigate("/transactions")}
              sx={{ color: "#059669", fontWeight: 600, fontSize: "12px", textTransform: "none" }}
            >
              View All
            </Button>
          </Box>
          <Divider sx={{ borderColor: "#F1F5F9" }} />

          {recentTxns.length === 0 ? (
            <Box sx={{ py: 5, textAlign: "center" }}>
              <Typography sx={{ color: "#CBD5E1", fontSize: "14px" }}>No transactions yet</Typography>
            </Box>
          ) : (
            recentTxns.map((txn, i) => {
              const isCredit = txn.type === "CREDIT";
              return (
                <Box key={txn.id || i}>
                  <Box sx={{ px: 3, py: 1.5, display: "flex", alignItems: "center", justifyContent: "space-between" }}>
                    <Box sx={{ display: "flex", alignItems: "center", gap: 1.5 }}>
                      <Avatar sx={{
                        width: 32, height: 32,
                        backgroundColor: isCredit ? "#D1FAE5" : "#FEF2F2",
                        color: isCredit ? "#059669" : "#EF4444",
                      }}>
                        {isCredit ? <ArrowUpwardIcon sx={{ fontSize: 16 }} /> : <ArrowDownwardIcon sx={{ fontSize: 16 }} />}
                      </Avatar>
                      <Box>
                        <Chip
                          label={txn.type}
                          size="small"
                          sx={{
                            height: 20, fontSize: "10px", fontWeight: 600,
                            backgroundColor: isCredit ? "#D1FAE5" : "#FEF2F2",
                            color: isCredit ? "#059669" : "#EF4444",
                            "& .MuiChip-label": { px: 0.8 },
                          }}
                        />
                        <Typography sx={{ fontSize: "11px", color: "#94A3B8", mt: 0.3 }}>
                          {new Date(txn.timestamp).toLocaleString()}
                        </Typography>
                      </Box>
                    </Box>
                    <Typography sx={{
                      fontWeight: 600, fontSize: "14px",
                      color: isCredit ? "#059669" : "#EF4444",
                    }}>
                      {isCredit ? "+" : "-"} Rs. {txn.amount}
                    </Typography>
                  </Box>
                  {i < recentTxns.length - 1 && <Divider sx={{ borderColor: "#F1F5F9" }} />}
                </Box>
              );
            })
          )}
        </Box>
      </Box>
    </Box>
  );
}
